export default __webpack_public_path__ + "static/media/meters.404f3dd8.svg";